import { Trip } from './../classes.js';
import { notification } from './../function/notification.js';
import { update_marker_display } from './../runtime/registerMap.js';

export class cTripManager {
	constructor() {
		this.trip_id = null;
		this.trigger = null;

		$('body').on('click', '.trip_manager--open', {obj: this}, function(e){
			e.preventDefault();
			//set vars
			this.trigger = $(this);
			
			//load the display
			e.data.obj.open();
		})
		
		$('body').on('click', '.trip_manager--close', {obj: this}, function(e){
			e.preventDefault();
			
			e.data.obj.close();
		})
		
		$('body').on('click', '#update_tr', {obj: this}, function(e){
			e.preventDefault();
			
			e.data.obj.update_tr();
		});
		
	}
	
	
	open(){
		$('#trip_manager').css("display", "flex").hide().fadeIn(200);
		this.set_trip();
	}
	
	
	close(){
		//set a hidden value in case a background save occurs
		Trip.content.trip.description = $('#tr__form--description').val();
		if(Trip.content.trip.description != null && Trip.content.trip.description != 'null'){
			$('[name="trip_description"]').text(Trip.content.trip.description);
		}else{
			$('[name="trip_description"]').text('');
		}
		
		//reset vars
		this.trip_id = null;
		this.trigger = null;
		//close the display
		$('#trip_manager').fadeOut(200);
	}
	
	
	set_trip(){
		//set vars for this click event
		this.trip_id = $('#trip_id').val();
	}
	
	
	async update_tr(){
		//create the form to upload a file
		let f = document.querySelector('#form__tr');
		let tr_form = new FormData(f);
		
		//add the trip_id of our current focus
		tr_form.append('trip_id', this.trip_id);
		
		try {
			let response = await fetch('/api/trip/update-settings', {
				method: 'POST',
				body: tr_form
			});

			if (!response.ok) {
				throw new Error(`HTTP error! status: ${response.status}`);
			}

			let result = await response.json();
			
			if(result.error){
				//error
				console.log(result);
			}else{
				this.close();
				notification('Trip updated');
			}
			
		} catch (error) {
			console.error('Error ***', error);
		}
	}
	
	
}